<template>
  <VueperSlides
    ref="slider"
    v-if="board"
    :duration="board.slide_timeout * 1000"
    :pauseOnHover="false"
    :touchable="false"
    :arrows="false"
    :fixed-height="fixedHeight"
    :bullets="false"
    :autoplay="board.is_slider == true && stop == false"
  >
    <VueperSlide
      class="w-100 h-100 slide"
      :style="
        'background: url(' +
        (slide.back_img ? slide.back_img : '') +
        '); ' +
        (!slide.back_img ? 'background: #fff;' : '') +
        'background-repeat: no-repeat;background-size: cover;'
      "
      v-for="(slide, idx) in pages"
      :key="idx"
    >
      <template v-slot:content>
        <GridLayout
          class="fill-width"
          :rowHeight="parseInt($variables.appHeight / 12)"
          :layout.sync="layout"
          :is-draggable="false"
          :is-resizable="false"
          :is-mirrored="false"
          :margin="[0, 0]"
          :use-css-transforms="true"
          autoSize
          responsive
          :maxRows="4"
          :colNum="4"
          :vertical-compact="true"
          :cols="{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }"
        >
          <div class="board">
            <div class="board-title" v-if="slide.title">
              {{ slide.title }}
            </div>
            <div class="board-content">
              <GridItem
                v-for="(item, i) in slide.value"
                :x="item.widget.pos_x"
                :y="item.widget.pos_y"
                :w="item.widget.cols"
                :h="item.widget.rows"
                :i="i"
                style="overflow-x: hidden !important"
                class="transparent"
                :key="i"
              >
                <div class="grid-item-content">
                  <component
                    :ref="`item-${item.widget.value.auto_scroll_interval || 10000}`"
                    :class="`item-rows-${item.widget.rows} item-cols-${item.widget.cols}`"
                    :settings="item.widget"
                    :is="item.widget.type"
                    :page_id="slide.id"
                    @updateFilteredAgents="updateAgentsList('slide-'+idx+'-'+i, $event)"
                  />
                </div>
              </GridItem>
            </div>
          </div>
        </GridLayout>
      </template>
    </VueperSlide>
  </VueperSlides>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import VueGridLayout from "vue-grid-layout";
import { isUndefined } from "lodash";
import { mapMutations } from "vuex";

import AgentList from "@/components/types/AgentList";
import AgentPointsList from "@/components/types/AgentPointsList";
import ProductStatistic from "@/components/types/ProductStatistic";
import DailyPerShift from "@/components/types/DailyPerShift";
import SummaryDaily from "@/components/types/SummaryDaily";
import WeeklyPerShift from "@/components/types/WeeklyPerShift";
import SummaryWeekly from "@/components/types/SummaryWeekly";
import MonthlyPerShift from "@/components/types/MonthlyPerShift";
import SummaryMonthly from "@/components/types/SummaryMonthly";
// import AgentListShiftsGroup from "@/components/types/AgentListShiftsGroup";
import SummaryShiftsGroup from "@/components/types/SummaryShiftsGroup";
import StaticReviewInfo from "@/components/types/StaticReviewInfo";
import ContentCarousel from "../components/types/ContentCarousel";
import CountDownGoal from "../components/types/CountDownGoal";
import ProgressBar from "../components/types/ProgressBar";

export default {
  props: ["board"],
  name: "slider-wrapper",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    VueperSlides,
    VueperSlide,
    agent_list: AgentList,
    agent_points_list: AgentPointsList,
    product_statistic: ProductStatistic,
    daily_per_shift: DailyPerShift,
    summary_daily: SummaryDaily,
    weekly_per_shift: WeeklyPerShift,
    summary_weekly: SummaryWeekly,
    monthly_per_shift: MonthlyPerShift,
    summary_monthly: SummaryMonthly,
    // agent_list_shifts_group: AgentListShiftsGroup,
    summary_shifts_group: SummaryShiftsGroup,
    static_review_info: StaticReviewInfo,
    info_carousel_data: ContentCarousel,
    count_down_goal: CountDownGoal,
    progress_bars: ProgressBar,
  },
  data() {
    return {
      fixedHeight: "100vh",
      current: null,
      stop: 0,

      layout: [{ x: 0, y: 0, w: 2, h: 2, i: "0" }],
      scrollIntervals: {},
      manualScrollIsActive: false,
      timer: null,
      agentsCrmIdsPerWidgetPrvt: {},
    };
  },
  computed: {
    agentsCrmIdsPerWidget() {
      return this.agentsCrmIdsPerWidgetPrvt;
    },
    autoScroll() {
      return this.$variables.autoScroll;
    },
    pages() {
      let res = this.board.pages.filter(el => el.active);
      res.sort((el1, el2) => el1.position - el2.position)
      return res;
    },
  },
  methods: {
    ...mapMutations({
      setAgentsCrmIdsPerBoard: 'boards/setAgentsCrmIdsPerBoard'
    }),
    updateAgentsList(pageId, agents) {
      this.agentsCrmIdsPerWidgetPrvt[pageId] = agents || [];
      const mergedUniqueCrmIds = [...new Set(Object.values(this.agentsCrmIdsPerWidget).flat())];
      this.setAgentsCrmIdsPerBoard(mergedUniqueCrmIds)
    },
    scrollTo(element, to, duration) {
      if (duration <= 0) { return; }
      const difference = to - element.scrollTop;

      const timeBeforeFrame = performance.now();
      requestAnimationFrame(() => {
        const frameTime = performance.now() - timeBeforeFrame;
        let perTick = (difference / duration) * frameTime;
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) {
          return;
        }
        this.scrollTo(element, to, duration - frameTime);
      });
    },
    registerAutoScroll() {
      const setElemInterval = (elem, interval) => {
        this.scrollIntervals[performance.now()] = setInterval(() => {
          if (this.manualScrollIsActive || !this.autoScroll) { return; }
          const scrollHeight = elem.scrollHeight;
          const viewport = elem.clientHeight;
          if (scrollHeight <= viewport) { return; }
          let scrollTop = elem.scrollTop;
          if (scrollTop + viewport < scrollHeight) {
            this.scrollTo(elem, scrollTop + viewport, 2000);
          } else {
            this.scrollTo(elem, 0, 200);
          }
        }, interval);
      }

      for (let key in this.$refs) {
        if (!key.includes('item-')) { continue; }
        const interval = +(key.split('-')?.[1] || 10000);
        for (const ref of this.$refs[key]) {
          const parent = ref.$el;
          if (!(parent && parent.getElementsByClassName)) { continue; }
          let isGroupWidget = false;
          const widgetsGroup = parent.getElementsByClassName('widget-group-content');
          if (widgetsGroup.length) {
            isGroupWidget = true;
            for (const elem of widgetsGroup) {
              setElemInterval(elem, interval);
            }
          }

          const widgets = parent.getElementsByClassName('widget-content');
          if (widgets.length) {
            for (const elem of widgets) {
              setElemInterval(elem, isGroupWidget ? interval * 0.75 : interval);
            }
          }
        }
      }
    },
    unregisterAutoScroll() {
      for (const key in this.scrollIntervals) {
        clearInterval(this.scrollIntervals[key]);
      }
    },
    onKeyUp(event) {
      event.stopPropagation();
      event.preventDefault();

      if (event.code === "Space") {
        if (
          isUndefined(this.$refs.slider) ||
          isUndefined(this.$refs.slider.pauseAutoplay) ||
          isUndefined(this.$refs.slider.resumeAutoplay)
        ) {
          return;
        }
        if (this.stop === 0) {
          this.stop = 1;
          this.$refs.slider.pauseAutoplay();
        } else {
          this.stop = 0;
          this.$refs.slider.resumeAutoplay();
        }

        return;
      }

      if (
        isUndefined(this.$refs.slider) ||
        isUndefined(this.$refs.slider.previous) ||
        isUndefined(this.$refs.slider.next)
      ) {
        return;
      }

      if (event.code === "ArrowLeft") {
        this.$refs.slider.previous();
      } else if (event.code === "ArrowRight") {
        this.$refs.slider.next();
      }
    }
  },
  created() {
    if (!this.board) {
      // window.location.href = "/";
    }
  },
  mounted() {
    if (this.board?.pages?.length === 1) { return; }
    setTimeout(() => {
      this.registerAutoScroll();
    }, 1000);
    window.addEventListener("keyup", this.onKeyUp);
  },
  beforeDestroy() {
    this.unregisterAutoScroll();
    window.removeEventListener("keyup", this.onKeyUp);
  },
};
</script>

<style lang="scss">
.fill-width {
  height: 100vh;
  box-sizing: border-box;
}

.grid-item-content {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex-grow: 1;
}

.v-application .transparent {
  background: transparent !important;
  background-color: transparent !important;
}

.transparent {
  background: transparent;
}

.vueperslide {
  padding: 0 10px;
  box-sizing: border-box;
  background-position: center !important;
}

// scrollbar
// scrollbar
// scrollbar
// scrollbar
// scrollbar
::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}
::-webkit-scrollbar-thumb {
  height: 6px;
  border: 4px solid #00000000;
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: #00000080;
  -webkit-box-shadow: inset -1px -1px 0px #0000000d,
    inset 1px 1px 0px #0000000d;
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
</style>
